import { Component } from 'react'
import { MdInfoOutline } from 'react-icons/md'
import { connect } from 'react-redux'

import {
  Modal,
  List,
  ListItem,
  Paper,
  Button
} from '../../../shared/NarusMaterial'
import { closeCloseableIssuesWarningModal } from '../actions'

class CloseableIssuesWarningModal extends Component {
  constructor (props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose () {
    const { dispatch } = this.props
    dispatch(closeCloseableIssuesWarningModal())
  }

  renderContent () {
    return (
      <div className='row'>
        <Paper
          zDepth={1}
          style={{
            width: '100%',
            margin: '16px',
            padding: '10px'
          }}
        >
          <List>{this.renderWarningIgaos()}</List>
        </Paper>
      </div>
    )
  }
  //
  // (
  // <ListItem key={`$igao${index}`}>
  // <div className="row middle">
  // <div className="col-xs-1">
  // <Svg src="info" />
  // </div>
  // <div className="col-11-xs">
  // {this.props.carePlans[cpId] &&
  // this.props.carePlans[cpId].description}
  // </div>
  // </div>
  // </ListItem>
  // )

  renderWarningIgaos () {
    const { carePlanIds, carePlans } = this.props
    return carePlanIds
      .map(cpId =>
        (carePlans[cpId] && carePlans[cpId].description
          ? carePlans[cpId].description
          : null))
      .sort()
      .map((cp, index) => (
        <ListItem key={`$igao${index}`}>
          <div className='row middle'>
            <div className='col-xs-1'>
              <MdInfoOutline size='1rem' />
            </div>
            <div className='col-11-xs'>{cp}</div>
          </div>
        </ListItem>
      ))
  }

  render () {
    const { open } = this.props
    if (!open) {
      return null
    }

    return (
      <Modal title='Warning: Open IGAOs'>
        {this.renderContent()}

        <div className='row margin-top'>
          <div className='modal-actions'>
            <Button
              label='Ok'
              onClick={this.handleClose}
              long
            />
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = redux => ({
  open:
    (redux.igao.closeableIssuesWarningModal &&
      redux.igao.closeableIssuesWarningModal.open) ||
    false,

  carePlanIds:
    (redux.igao.closeableIssuesWarningModal &&
      redux.igao.closeableIssuesWarningModal.carePlanIds) ||
    [],

  carePlans:
    (redux.patient.compartment && redux.patient.compartment.CarePlan) || {}
})

export default connect(mapStateToProps)(CloseableIssuesWarningModal)
